import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { HolidayBanner, GiftSets } from "@/components/shop/HolidaySections";
import { GiftBoxBuilder } from "@/components/shop/GiftBoxBuilder";
import { GiftQuiz } from "@/components/shop/GiftQuiz";
import { useSeason } from "@/lib/holiday";
import { useSeo } from "@/lib/seo";
import { useI18n } from "@/lib/i18n";

export default function Gifts() {
  const { hash } = useLocation();
  const { active } = useSeason();
  const { t } = useI18n();
  useSeo(active ? t("seo_gifts") : t("nav_gifts"));
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 600);
    return () => clearTimeout(t);
  }, [hash]);
  return (
    <div data-testid="gifts-page">
      {active ? <HolidayBanner /> : <div className="pt-10" />}
      <GiftSets />
      <GiftQuiz />
      <GiftBoxBuilder />
    </div>
  );
}
